module.exports = __webpack_public_path__ + "static/media/chess-book-sub.af810fe1.png";